import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useCallback, useContext } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { ConfirmationModal } from '../../../../subcomponents/confirmation-modal/confirmation-modal';
import { MemberPaymentCardWalletContextInstance } from '../../types/context';
import { getFormattedMessage } from '../../utils/get-formatted-message';
export var MemberPaymentCardWalletAddCardModalType;
(function (MemberPaymentCardWalletAddCardModalType) {
    MemberPaymentCardWalletAddCardModalType["Reactivate"] = "Reactivate";
    MemberPaymentCardWalletAddCardModalType["MakePrimaryAndAcceptTermsAndConditions"] = "MakePrimaryAndAcceptTermsAndConditions";
    MemberPaymentCardWalletAddCardModalType["MakePrimary"] = "MakePrimary";
})(MemberPaymentCardWalletAddCardModalType || (MemberPaymentCardWalletAddCardModalType = {}));
export const MemberPaymentCardWalletAddCardModal = observer(props => {
    const i18n = useI18n();
    const { type, show, reactivationPrice, startAddingPaymentCard, hideModal, onMakePrimaryChosen } = props;
    const { displayText } = useContext(MemberPaymentCardWalletContextInstance);
    const onPrimaryButtonClicked = useCallback(() => {
        onMakePrimaryChosen();
        if (startAddingPaymentCard)
            startAddingPaymentCard();
        hideModal();
    }, [onMakePrimaryChosen, hideModal, startAddingPaymentCard]);
    const onSecondaryButtonClicked = useCallback(() => {
        startAddingPaymentCard === null || startAddingPaymentCard === void 0 ? void 0 : startAddingPaymentCard();
        hideModal();
    }, [hideModal, startAddingPaymentCard]);
    if (!type)
        return null;
    return (_jsx(ConfirmationModal, Object.assign({}, getModalDisplayText(type, displayText, i18n, reactivationPrice), { show: show, onCancel: hideModal, onAccept: onPrimaryButtonClicked, onSecondaryAction: onSecondaryButtonClicked })));
});
MemberPaymentCardWalletAddCardModal.displayName = 'MemberPaymentCardWalletAddCardModal';
const getModalDisplayText = (type, displayText, i18n, reactivationPrice) => {
    switch (type) {
        case MemberPaymentCardWalletAddCardModalType.Reactivate:
            return {
                heading: displayText.setPrimaryCardReactivateSubscriptionPromptTitle,
                message: getFormattedMessage(displayText.setPrimaryCardReactivateSubscriptionPromptMessage, i18n, undefined, reactivationPrice),
                acceptLabel: displayText.setPrimaryCardReactivateSubscriptionPromptAcceptButtonLabel,
                secondaryActionLabel: displayText.setPrimaryCardReactivateSubscriptionPromptDeclineButtonLabel,
                cancelLabel: displayText.promptCancelButtonLabel
            };
        case MemberPaymentCardWalletAddCardModalType.MakePrimaryAndAcceptTermsAndConditions:
            return {
                heading: displayText.addPrimaryCardTermsAndConditionsPromptTitle,
                message: displayText.addPrimaryCardTermsAndConditionsPromptMessage,
                acceptLabel: displayText.addPrimaryCardTermsAndConditionsPromptAcceptButtonLabel,
                secondaryActionLabel: displayText.addPrimaryCardTermsAndConditionsPromptDeclineButtonLabel,
                cancelLabel: displayText.promptCancelButtonLabel
            };
        case MemberPaymentCardWalletAddCardModalType.MakePrimary:
        default:
            return {
                heading: displayText.makePrimaryCardPromptTitle,
                message: displayText.makePrimaryCardPromptMessage,
                acceptLabel: displayText.makePrimaryCardPromptAcceptButtonLabel,
                secondaryActionLabel: displayText.makePrimaryCardPromptDeclineButtonLabel,
                cancelLabel: displayText.promptCancelButtonLabel
            };
    }
};
